/* eslint-disable default-case */
import * as React from 'react';
import { GridComponent, ColumnsDirective, ColumnDirective, Toolbar, ExcelExport, PdfExport, DetailRow, Filter, Inject, Sort, Page } from '@syncfusion/ej2-react-grids';
import { SampleBase } from './sample-base';
import * as CustomJS from '../Custom';
import _ from 'underscore/underscore-min';
import { random } from 'underscore';
import { toast } from 'react-toastify';
import BlockUi from '@availity/block-ui';

function headerTemplate(props) {
    return (
        <div>
            <span style={{ fontSize: '0.9vw', fontWeight: 'bolder' }}>{props.headerText}</span>
        </div>
    );
}

function fieldTemplate(props) {
    return (
        <div>
            <span style={{ fontSize: '1.0vw', color: '#133B95', fontWeight: 'bold' }}>
                {props[props.column.field]}
            </span>
        </div>
    );
}

function fieldTemplateInt(props) {
    return (
        <div>
            <span style={{ fontSize: '1.0vw', color: 'purple', fontWeight: 'bold' }}>
                {(props[props.column.field] || 0).toLocaleString('it-IT')}
            </span>
        </div>
    );
}

function fieldTemplateDecimal(props) {
    return (
        <div>
            <span style={{ fontSize: '1.0vw', color: 'purple', fontWeight: 'bold' }}>
                {(props[props.column.field] || 0).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </span>
        </div>
    );
}

function fieldTemplatePerc(props) {
    return (
        <div>
            <span style={{ fontSize: '1.0vw', color: 'purple', fontWeight: 'bold' }}>
                {(props[props.column.field] || 0).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%
            </span>
        </div>
    );
}

function fieldTemplateEuro(props) {
    return (
        <div>
            <span style={{ fontSize: '1.0vw', color: 'purple', fontWeight: 'bold' }}>
                € {(props[props.column.field] || 0).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </span>
        </div>
    );
}

function fieldTemplateSinistriTripla(props) {
    const aperti = props.SinistriAperti || 0;
    const chiusura = props.SinistriInChiusura || 0;
    const controllo = props.SinistriInControllo || 0;

    return (
        <div>
            <span style={{ fontSize: '1.0vw', color: 'purple', fontWeight: 'bold' }}>
                {`${aperti.toLocaleString('it-IT')} / ${chiusura.toLocaleString('it-IT')} / ${controllo.toLocaleString('it-IT')}`}
            </span>
        </div>
    );
}

function fieldTemplateApertiTotali(props) {
    const tot = props.SinistriAperti_Totale || 0;
    const s = props.SinistriAperti_Semplice || 0;
    const i = props.SinistriAperti_Intermedio || 0;
    const c = props.SinistriAperti_Complesso || 0;

    const total = tot.toLocaleString('it-IT');
    const details = `(S=${s.toLocaleString('it-IT')}, I=${i.toLocaleString('it-IT')}, C=${c.toLocaleString('it-IT')})`;

    return (
        <div>
            <span>
                <span style={{
                    fontSize: '1.1vw',
                    fontWeight: 'bolder',
                    color: 'black'
                }}>
                    {total}
                </span>

                <span style={{
                    fontSize: '0.9vw',
                    fontWeight: '800',
                    color: '#6E6E6E',
                    marginLeft: '6px'
                }}>
                    {details}
                </span>
            </span>
        </div>
    );
}

function aggregaDatiPerTeamLeader(rawData) {
    const filtered = rawData.filter(r =>
        !CustomJS.isNullEmpty(r.TeamLeader) &&
        !CustomJS.isNullEmpty(r.Perito) &&
        hasSinistriNonZero(r)
    );

    const grouped = _.groupBy(filtered, 'TeamLeader');

    const campiSomma = [
        'SinistriAperti',
        'SinistriInChiusura',
        'SinistriInControllo',
        'SinistriChiusiMeseCorrente',
        'NumSinistriDefiniti_1_10000',
        'SinistriAperti_Totale',
        'SinistriAperti_Semplice',
        'SinistriAperti_Intermedio',
        'SinistriAperti_Complesso'
    ];

    const campiMedia = [
        'MediaMensileSinistriChiusi',
        'MediaGiorniSinistriAperti',
        'MediaGiorniSinistriRestituiti',
        'MediaSinistriDefiniti_1_10000',
        'PercentualeScaricoAnnoCorrente',
        'PercentualeRevisionati',
        'LiquidatoMedio'
    ];
    const result = Object.keys(grouped).map(teamLeader => {
        const periti = grouped[teamLeader];
        const numPeriti = periti.length;

        const totale = {
            TeamLeader: teamLeader,
            NumPeriti: numPeriti,
            Periti: periti
        };

        campiSomma.forEach(campo => {
            totale[campo] = _.reduce(periti, (s, p) => s + (p[campo] || 0), 0);
        });

        campiMedia.forEach(campo => {
            totale[campo] =
                numPeriti > 0
                    ? _.reduce(periti, (s, p) => s + (p[campo] || 0), 0) / numPeriti
                    : 0;

            totale[campo] = Math.round(totale[campo] * 100) / 100;
        });

        // Media ponderata: (% / 100) * aperti_totale per ogni perito, diviso il totale aperti del gruppo
        const sumOver45 = _.reduce(periti, (s, p) => s + ((p.PercentualeSinistriOver45GG || 0) / 100) * (p.SinistriAperti_Totale || 0), 0);
        const totAperti = totale.SinistriAperti_Totale;
        totale.PercentualeSinistriOver45GG = totAperti > 0
            ? Math.round((sumOver45 / totAperti) * 100 * 100) / 100
            : 0;

        return totale;
    });
    const filtrati = result.filter(t => hasSinistriNonZero(t));

    return _.sortBy(filtrati, 'TeamLeader');
}

function hasSinistriNonZero(obj) {
    const aperti = obj.SinistriAperti || 0;
    const chiusura = obj.SinistriInChiusura || 0;
    const controllo = obj.SinistriInControllo || 0;

    return (aperti + chiusura + controllo) > 0;
}

export default class PaginaTeamLeader extends SampleBase {
    constructor() {
        super(...arguments);
        this.toolbarOptions = ['ExcelExport', 'Search'];
        this.pageSettings = { pageSize: 10 };
        this.toggleBlocking = this.toggleBlocking.bind(this);
    }
    state = {
        blocking: false,
        dataSource: [],
        allPeriti: []       // dataSource flat per la childGrid (tutti i periti di tutti i team leader)
    }
    toggleBlocking() {
        this.setState({ blocking: !this.state.blocking });
    }
    toolbarClick(args) {
        switch (args.item.properties.prefixIcon) {
            case 'e-pdfexport':
                this.gridInstance.pdfExport();
                break;
            case 'e-excelexport':
                // hierarchyExportMode: 'All' esporta TUTTE le child grid in Excel
                this.gridInstance.excelExport({ hierarchyExportMode: 'All' });
                break;
        }
    }
    onQueryCellInfoMaster(args) {
        if (args.column.field === 'PercentualeSinistriOver45GG') {
            args.cell.style.color = 'purple';
            args.cell.style.fontSize = '1.1vw';
            args.cell.style.fontWeight = 'bold';

            const val = args.data.PercentualeSinistriOver45GG;

            if (val > 40) {
                args.cell.style.color = 'whitesmoke';
                args.cell.bgColor = '#e24747';
            }
            else if (val > 20) {
                args.cell.bgColor = '#FF9900';
            }
            else if (val > 10) {
                args.cell.bgColor = 'yellow';
            }
            else {
                args.cell.bgColor = '#4DFF4D';
            }
        }
    }
    onQueryCellInfoDetail(args) {
        if (args.column.field === 'PercentualeSinistriOver45GG') {
            args.cell.style.color = 'purple';
            args.cell.style.fontSize = '1.0vw';
            args.cell.style.fontWeight = 'bold';

            const val = args.data.PercentualeSinistriOver45GG;

            if (val > 40) {
                args.cell.style.color = 'whitesmoke';
                args.cell.bgColor = '#D75555';
            }
            else if (val > 20) {
                args.cell.bgColor = '#FF9900';
            }
            else if (val > 10) {
                args.cell.bgColor = 'yellow';
            }
            else {
                args.cell.bgColor = '#4DFF4D';
            }
        }
    }
    onDataBoundMaster() {
        const grid = document.getElementById('GridTeamLeader');

        if (!grid) return;

        const headerRow = grid.querySelector('.e-gridheader .e-headercontent table thead tr');
        if (headerRow) {
            for (let ind = 0; ind < headerRow.children.length; ind++) {
                headerRow.children[ind].style.backgroundColor = 'Linen';
            }
        }

        const testoEl = document.getElementById('TestoDatiAggiornati');
        if (testoEl) {

            const now = new Date();

            testoEl.innerText =
                `Dati aggiornati al ${now.getDate().toString().padStart(2,'0')}/` +
                `${(now.getMonth()+1).toString().padStart(2,'0')}/` +
                `${now.getFullYear()} alle ore ${now.getHours().toString()}:` +
                `${now.getMinutes().toString().padStart(2,'0')}`;
        }
    }
    onDataBoundDetail() {
        document.querySelectorAll('.e-detailrow .e-gridheader thead tr')
            .forEach(headerRow => {
                for (let ind = 0; ind < headerRow.children.length; ind++) {
                    headerRow.children[ind].style.backgroundColor = '#E3F2FD';
                }
            });
    }
    onRowDataBoundMaster(args) {
    }
    // Replica il padding:20 che era nel <div> wrapper del vecchio detailTemplate
    onDetailDataBound(args) {
        if (args.detailElement) {
            args.detailElement.style.padding = '20px';
        }
    }
    componentDidMount() {
        this.caricaDati();
    }
    caricaDati() {
        this.toggleBlocking();
        CustomJS.callAPI(
            `${CustomJS.APIMonitorURLProd}/api/Monitor/portingTutteAPI/teamLeader/[NO]/[NO]/[NO]/[NO]/[NO]/[NO]`, '', 'GET', '', retData => {
                this.toggleBlocking();
                const aggregati = aggregaDatiPerTeamLeader(retData)
                    .filter(tl => (tl.TeamLeader || '').trim().toLowerCase() !== 'leonardo bruno');

                // =====================================================================
                // FLAT DATA SOURCE PER childGrid
                // Estraiamo tutti i record Periti in un unico array piatto.
                // Ogni record perito ha già il campo "TeamLeader" dalla sorgente originale,
                // che verrà usato come queryString per collegare parent → child.
                // =====================================================================
                const allPeriti = aggregati.reduce((acc, tl) => {
                    return acc.concat(tl.Periti || []);
                }, []);

                this.setState({ dataSource: aggregati, allPeriti });
            },
        error => {
            this.toggleBlocking();
            let messaggio = (_.isString(error) && error.indexOf('Not Found')) > -1
                ? CustomJS.messaggioAPIBackendNonTrovata
                : CustomJS.messaggioNoBackend;
            toast.warn(messaggio, {
                containerId: 'toastContainer1',
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                newestOnTop: true,
                rtl: false,
                pauseOnFocusLoss: true
            });
            
            toast.warn("Errore chiamata API");
        }, true, false);
    }

    // =====================================================================
    // childGrid config (GridModel) AL POSTO DI detailTemplate
    //
    // MOTIVO: hierarchyPrintMode='All' funziona SOLO con la proprietà
    //         childGrid + queryString, NON funziona con detailTemplate.
    //         (Limitazione documentata Syncfusion EJ2)
    //
    // COME FUNZIONA:
    //   - allPeriti è un array piatto con TUTTI i periti di tutti i TL
    //   - queryString: 'TeamLeader' filtra automaticamente i periti
    //     mostrando solo quelli il cui campo TeamLeader corrisponde
    //     al valore TeamLeader della riga parent
    //
    // NOTA TEMPLATE: le funzioni React (fieldTemplate, fieldTemplatePerc, ecc.)
    //   passate come "template" in un GridModel *dovrebbero* funzionare
    //   perché il wrapper React di Syncfusion processa anche la childGrid
    //   con lo stesso engine del componente padre.
    //   Se per qualche versione non dovessero renderizzare, il fallback è
    //   spostare la formattazione interamente dentro queryCellInfo (onQueryCellInfoDetail)
    //   usando args.cell.innerHTML per costruire l'HTML formattato.
    // =====================================================================
    getChildGridOptions() {
        return {
            dataSource: this.state.allPeriti,
            queryString: 'TeamLeader',
            gridLines: 'Both',
            allowSelection: false,
            enableHover: false,
            queryCellInfo: this.onQueryCellInfoDetail.bind(this),
            dataBound: this.onDataBoundDetail.bind(this),
            columns: [
                {
                    field: 'Perito',
                    headerText: 'Perito',
                    width: '10%',
                    headerTemplate: headerTemplate,
                    template: fieldTemplate,
                    textAlign: 'Center'
                },
                {
                    field: 'SinistriAperti',
                    headerText: 'Sinistri Aperti / In Chiusura / In Controllo',
                    headerTemplate: headerTemplate,
                    template: fieldTemplateSinistriTripla,
                    textAlign: 'Center'
                },
                {
                    field: 'SinistriChiusiMeseCorrente',
                    headerText: 'Sinistri Chiusi Mese Corrente',
                    headerTemplate: headerTemplate,
                    template: fieldTemplateInt,
                    textAlign: 'Center'
                },
                {
                    field: 'MediaMensileSinistriChiusi',
                    headerText: 'Media Mensile Sinistri Chiusi',
                    headerTemplate: headerTemplate,
                    template: fieldTemplateDecimal,
                    textAlign: 'Center'
                },
                {
                    field: 'MediaGiorniSinistriAperti',
                    headerText: 'Media Giorni Sinistri Aperti',
                    headerTemplate: headerTemplate,
                    template: fieldTemplateDecimal,
                    textAlign: 'Center'
                },
                {
                    field: 'MediaGiorniSinistriRestituiti',
                    headerText: 'Media Giorni Sinistri Restituiti',
                    headerTemplate: headerTemplate,
                    template: fieldTemplateDecimal,
                    textAlign: 'Center'
                },
                {
                    field: 'PercentualeScaricoAnnoCorrente',
                    headerText: '% Scarico Anno Corrente',
                    headerTemplate: headerTemplate,
                    template: fieldTemplatePerc,
                    textAlign: 'Center'
                },
                {
                    field: 'PercentualeSinistriOver45GG',
                    headerText: '% Sinistri Over 45 GG',
                    headerTemplate: headerTemplate,
                    template: fieldTemplatePerc,
                    textAlign: 'Center'
                },
                // {
                //     field: 'NumSinistriDefiniti_1_10000',
                //     headerText: 'Sinistri Definiti tra 1 e 10000',
                //     headerTemplate: headerTemplate,
                //     template: fieldTemplateInt,
                //     textAlign: 'Center'
                // },
                {
                    field: 'PercentualeRevisionati',
                    headerText: '% Revisionati',
                    headerTemplate: headerTemplate,
                    template: fieldTemplatePerc,
                    textAlign: 'Center'
                },
                {
                    field: 'SinistriApertiTotali',
                    headerText: 'Sinistri Aperti (S, I, C)',
                    width: '15%',
                    headerTemplate: headerTemplate,
                    template: fieldTemplateApertiTotali,
                    textAlign: 'Center'
                }
                // {
                //     field: 'MediaSinistriDefiniti_1_10000',
                //     headerText: 'Media Liquidato tra 1 e 10000',
                //     headerTemplate: headerTemplate,
                //     template: fieldTemplateEuro,
                //     textAlign: 'Center'
                // },
                // {
                //     field: 'LiquidatoMedio',
                //     headerText: 'Liquidato Medio Generale',
                //     headerTemplate: headerTemplate,
                //     template: fieldTemplateEuro,
                //     textAlign: 'Center'
                // }
            ]
        };
    }

    render() {
        // Costruiamo childGrid options con il dataSource aggiornato ad ogni render
        const childGridOptions = this.getChildGridOptions();

        return (
            <React.Fragment>
                <BlockUi tag='div' id='blockUI1' blocking={this.state.blocking} keepInView={true} loader={CustomJS.loaderSpinners[random(CustomJS.loaderSpinners.length - 1)]}>
                <GridComponent
                    id="GridTeamLeader"
                    ref={grid => this.gridInstance = grid}
                    dataSource={this.state.dataSource}
                    toolbar={this.toolbarOptions}
                    allowPaging={true}
                    allowExcelExport={true}
                    hierarchyPrintMode='All'
                    childGrid={childGridOptions}
                    detailDataBound={this.onDetailDataBound.bind(this)}
                    gridLines='Both'
                    allowTextWrap={true}
                    allowSelection={false}
                    enableHover={false}
                    toolbarClick={this.toolbarClick.bind(this)}
                    queryCellInfo={this.onQueryCellInfoMaster.bind(this)}
                    dataBound={this.onDataBoundMaster.bind(this)}
                    rowDataBound={this.onRowDataBoundMaster.bind(this)}>
                    <ColumnsDirective>
                        <ColumnDirective field='TeamLeader'
                            headerText='Team Leader'
                            headerTemplate={headerTemplate}
                            template={fieldTemplate}
                            textAlign='Center' />

                        <ColumnDirective field='NumPeriti'
                            headerText='Num. Periti'
                            headerTemplate={headerTemplate}
                            template={fieldTemplateInt}
                            width='7%'
                            textAlign='Center' />

                        <ColumnDirective field='SinistriAperti'
                            headerText='Totale Sinistri Aperti / In Chiusura / In Controllo'
                            headerTemplate={headerTemplate}
                            template={fieldTemplateSinistriTripla}
                            textAlign='Center' />

                        <ColumnDirective field='SinistriChiusiMeseCorrente'
                            headerText='Totale Sinistri Chiusi Mese Corrente'
                            headerTemplate={headerTemplate}
                            template={fieldTemplateInt}
                            textAlign='Center' />

                        <ColumnDirective field='MediaMensileSinistriChiusi'
                            headerText='Media Mensile Sinistri Chiusi'
                            headerTemplate={headerTemplate}
                            template={fieldTemplateDecimal}
                            textAlign='Center' />

                        <ColumnDirective field='MediaGiorniSinistriAperti'
                            headerText='Media Giorni Sinistri Aperti'
                            headerTemplate={headerTemplate}
                            template={fieldTemplateDecimal}
                            textAlign='Center' />

                        <ColumnDirective field='MediaGiorniSinistriRestituiti'
                            headerText='Media Giorni Sinistri Restituiti'
                            headerTemplate={headerTemplate}
                            template={fieldTemplateDecimal}
                            textAlign='Center' />

                        <ColumnDirective field='PercentualeScaricoAnnoCorrente'
                            headerText='% Scarico Anno Corrente'
                            headerTemplate={headerTemplate}
                            template={fieldTemplatePerc}
                            textAlign='Center' />

                        <ColumnDirective field='PercentualeSinistriOver45GG'
                            headerText='% Sinistri Over 45 GG'
                            headerTemplate={headerTemplate}
                            template={fieldTemplatePerc}
                            textAlign='Center' />

                        {/* <ColumnDirective field='NumSinistriDefiniti_1_10000'
                            headerText='Totale Sinistri Definiti tra 1 e 10000'
                            headerTemplate={headerTemplate}
                            template={fieldTemplateInt}
                            textAlign='Center' /> */}

                        <ColumnDirective field='PercentualeRevisionati'
                            headerText='% Revisionati'
                            width='8%'
                            headerTemplate={headerTemplate}
                            template={fieldTemplatePerc}
                            textAlign='Center' />

                            <ColumnDirective 
                                field='SinistriApertiTotali'
                                headerText="Sinistri Aperti (S, I, C)"
                                width='15%'
                                headerTemplate={headerTemplate}
                                template={fieldTemplateApertiTotali}
                                textAlign='Center' />

                        {/* <ColumnDirective field='MediaSinistriDefiniti_1_10000'
                            headerText='Media Liquidato tra 1 e 10000'
                            headerTemplate={headerTemplate}
                            template={fieldTemplateEuro}
                            textAlign='Center' />

                        <ColumnDirective field='LiquidatoMedio'
                            headerText='Liquidato Medio Generale'
                            headerTemplate={headerTemplate}
                            template={fieldTemplateEuro}
                            textAlign='Center' /> */}
                    </ColumnsDirective>
                    <Inject services={[Toolbar, ExcelExport, DetailRow, Page, Sort, Filter]} />
                </GridComponent>
                </BlockUi>
            </React.Fragment>
        );
    }
}
